// import { HttpAdapter } from "../../../config/http/http.adapter";
import { HttpAdapter } from '../../../config/http/http.adapter';
import { LastTransactionResponse } from '../../../infraestructure/interfaces/last-transaction.interface';
import { LastTransactionMapper } from '../../../infraestructure/mappers/last-transacion.mapper';
import { LastTransaction } from '../../entities/general/LastTransaction.entity';
import { handleError } from '../../handle-error/handleError';
import moment from 'moment';
import { MovementType } from '../../types/movement-type';

// Fecha actual en el formato deseado
const currentDate = moment().format('YYYY-MM-DD');

// Fecha restando 12 meses
const originDate = moment().subtract(12, 'months').format('YYYY-MM-DD');

interface Props {
  clientId: string;
  dateFrom: string | Date;
  dateTo: string | Date;
  bankId?: string;
  page: number;
  pageSize: number;
  accountNumber?: string;
  movementType?: MovementType;
}

export const LastTransactionUseCases = async (
  fetcher: HttpAdapter,
  props: Props
): //   fetcher: HttpAdapter
Promise<LastTransaction> => {
  try {
    const {
      clientId,
      dateFrom = originDate,
      dateTo = currentDate,
      bankId,
      page = 1,
      pageSize = 10,
      accountNumber,
      movementType,
    } = props;

    const requestData: Record<string, string> = {
      clientId: `${clientId}`,
      dateFrom: `${dateFrom}`,
      dateTo: `${dateTo}`,
    };

    if (accountNumber) {
      requestData.accountNumber = `${accountNumber}`;
    }

    if (bankId) {
      requestData.bankId = `${bankId}`;
    }

    if (movementType) {
      requestData.movementType = `${movementType}`;
    }

    const response = await fetcher.post<LastTransactionResponse>(
      `/data-ms/last-transactions?page=${page}&page-size=${pageSize}`,
      requestData
    );

    return LastTransactionMapper.fromResponseToEntity(response);
  } catch (error: any) {
    const processedError = handleError(error);
    console.error('Error procesado:', processedError);
    throw new Error(`${processedError.message} ${processedError.status}`);
  }
};
